export const Mode = {
  Hover: 'hover',
  ClickToClose: 'click-to-close',
};
